import { getLocale } from "../runtime";

const sv_oneproduct = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `${inputs.value} produkt`
};

const oneproduct = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_oneproduct(inputs)
	return "oneProduct";
};

export { oneproduct as "oneProduct" };